export default "__VITE_ASSET__Xtry$YMp__"